import { notifyError, notifySuccess } from "@linkfluence/core/notifications";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import useFeedbackModal from "@radarly/components/insight-pages/discovery/footer/useFeedbackModal";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { tr } from "@radarly/i18n";
import { DiscoveryFeedback, FeedbackReason } from "@radarly/models/discovery";
import { DiscoveryRow } from "@radarly/models/discovery";
import { useDiscoverySendFeedback } from "./useDiscoverySendFeedback";

export function useDiscoveryFeedback() {
  const project = useCurrentProject();
  const workspaceId = useCurrentWorkspaceId();
  const locale = useCurrentUserLocale();

  const projectId = project.id;

  const { sendFeedback, isLoading } = useDiscoverySendFeedback();

  const onFeedback = async (
    discoveryRow: DiscoveryRow,
    discoveryFeedback: DiscoveryFeedback
  ) => {
    try {
      await sendFeedback(
        projectId,
        workspaceId,
        discoveryRow.page,
        discoveryFeedback
      );

      notifySuccess(
        tr(locale, "INSIGHT_PAGES::DISCOVERY::FEEDBACK::NOTIFICATION_SUCCESS")
      );
    } catch (e) {
      notifyError("Could not send feedback. Please try again.");
    }
  };

  const onPositiveFeedback = async (discoveryRow: DiscoveryRow) => {
    await onFeedback(discoveryRow, { feedback: true });
  };

  const sendNegativeFeedback = async (
    discoveryRow: DiscoveryRow,
    reason: FeedbackReason,
    message?: string
  ) => {
    await onFeedback(discoveryRow, { feedback: false, reason, message });
  };

  const { FeedbackModal, open } = useFeedbackModal(
    sendNegativeFeedback,
    isLoading,
    locale
  );

  return { FeedbackModal, onPositiveFeedback, onNegativeFeedback: open };
}
